export * from './generateDownload';

export function assertUnreachable(_x: never): never {
  throw new Error("Didn't expect to get here");
}
